import { useState } from "react";
import { useAuth } from "../../lib/auth";
import { Navigate } from "react-router-dom";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Échec de connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#2D2A26] flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="bg-[#FDFBF7] rounded-3xl p-10 max-w-md w-full">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-12 h-12 rounded-full bg-[#C87A5E]/15 flex items-center justify-center text-[#C87A5E]">
            <Lock size={20} />
          </div>
          <div>
            <div className="overline">Administration</div>
            <h1 className="font-serif text-2xl">Connexion</h1>
          </div>
        </div>
        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <label className="overline block mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-transparent border-b border-[#2D2A26]/30 py-2.5 focus:border-[#C87A5E] outline-none"
              data-testid="login-email"
            />
          </div>
          <div>
            <label className="overline block mb-2">Mot de passe</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-transparent border-b border-[#2D2A26]/30 py-2.5 focus:border-[#C87A5E] outline-none"
              data-testid="login-password"
            />
          </div>
          {error && <div className="text-sm text-red-700" data-testid="login-error">{error}</div>}
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-50" data-testid="login-submit">
            {loading ? "Connexion…" : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
